import { Capacitor } from '@capacitor/core';
import { tap } from 'rxjs/operators';
import { FileOpener } from '@capacitor-community/file-opener'
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { HttpClient } from '@angular/common/http';

export function DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
}


export const blobToString = (blob: Blob) => {
  const reader = new FileReader();
  reader.readAsText(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const blobToBase64 = (blob: Blob) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export async function urlToBase64(url: string): Promise<string> {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Erreur lors du chargement ou de la conversion de l\'image:', error);
    return '';
  }
}

export function downloadFile(http: HttpClient, url: string, json: { [key: string]: any }, headers: { [key: string]: any }) {
  headers['content-type'] = 'application/json'
  return http.post(url, json, {headers : headers}).pipe(
      tap(async (data: { [key: string]: any }) => {
        var datas = []
        if(data['datas'] !== undefined) {
          datas = data['datas']
        } else {
          datas = [data]
        }

        for(var d of datas) {
          if (Capacitor.isNativePlatform()) {
            Filesystem.checkPermissions().then(permission => {
              console.log(permission)
              try {
                Filesystem.writeFile({
                  path: d['fileName'],
                  data: d['data'],
                  directory: Directory.Data,
                  encoding: Encoding.UTF8,
                })
                .then((res) => {
                  console.log('res', res);
                  Filesystem.getUri({
                    directory: Directory.Data,
                    path: d['fileName'],
                  }).then(
                    (getUriResult) => {
                      const path = getUriResult.uri;
                      console.log("The file's path : " + path);
                      console.log(Capacitor.convertFileSrc(getUriResult.uri));
                      FileOpener.open({
                        filePath: path,
                        contentType: d['type'],
                      });
                    },
                    (error) => {
                      console.log(error);
                    }
                  );
                })
                .catch((err) => {
                  console.log('Error', err);
                });
              } catch (e) {
                console.error('Unable to write file', e);
              }
            }).catch((err) => {
              console.log('Error', err);
            });
          } else {
            var blob;
            if(data['type'] == 'text/calendar') {
              blob = new Blob([data['data']], { type: data['type'] })
            } else {
              data['data'] = atob(data['data'])
              const ia = new Uint8Array(data['data'].length)
              for (let i = 0; i < data['data'].length; i++)
                  ia[i] = data['data'].charCodeAt(i)
              blob = new Blob([ia], { type: data['type'] })
            }

            const url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";

            a.href = url;
            a.download = data['fileName'];
            a.click();
            setTimeout(function(){ window.URL.revokeObjectURL(url); }, 30000);
          }
        }
      }),
    );
}

//This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
export function calcCrow(lat1: number, lon1: number, lat2: number, lon2: number) 
{
  var R = 6371; // km
  var dLat = toRad(lat2-lat1);
  var dLon = toRad(lon2-lon1);
  var lat1 = toRad(lat1);
  var lat2 = toRad(lat2);

  var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c;
  return d;
}

// Converts numeric degrees to radians
function toRad(Value: number) 
{
    return Value * Math.PI / 180;
}
